module.exports = __webpack_public_path__ + "media/country_flags/kv-8a83b3a7.png";